/** Color, Please copy authority. Keep product language here when it belongs to
 * the engine journey; highly visual home and result scenes live beside markup. */
export const copy = {
  brand: {
    product: "Color, Please",
    byline: "A presentation tool by pitch.dog",
    shortPromise: "Keep the feeling. Give every color a job.",
  },
  source: {
    headline: "Choose the image your deck should feel like.",
    body: "A photograph, film still, painting, texture, product shot, or reference with the right temperature.",
    sourceMap: "What came from your image",
    sourceMapHint: "The colors we found, the jobs they now have, and anything you asked us to keep.",
  },
  route: {
    colour: {
      quick: "Make my palette now",
      guided: "Tune it first",
    },
  },
  questions: {
    viewing: {
      title: "Where must these colors hold up?",
      note: "Choose every place that matters. A projector and a phone are different little beasts.",
    },
    pressure: {
      title: "How full are your typical slides?",
      note: "Be honest. We are coloring the deck you have, not the fantasy edit.",
    },
    sourceRelationship: {
      title: "How closely should we stay with the image?",
      note: "Keep it faithful, borrow the mood, or give the palette permission to wander—with supervision.",
    },
    baseMode: {
      title: "Should the room feel light or dark?",
      note: "Choose one, ask for both, or let the image make the call.",
    },
  },
  processing: {
    image: ["Listening to the image", "Finding the useful colors", "Giving each one a job", "Putting them to work on slides"],
    noPercent: "A moment. Good light dislikes being rushed.",
  },
  result: {
    evidenceLabel: "The receipts",
    revise: "Change my answers",
  },
  correction: {
    eyebrow: "THE COLOR LAB",
    headline: "Keep the feeling. Change the weather.",
    vary: "Try a nearby accent",
    resetColour: "Reset the palette",
    resetWarning: "This clears your edits, not the image. No ceremonial bonfire required.",
  },
  export: {
    title: "Take your palette with you",
    actions: {
      css: "Copy CSS variables",
      json: "Download design tokens",
      manifest: "Download sources and evidence",
      print: "Print the specimen",
    },
  },
  project: {
    saved: "Remembered on this device.",
    clear: "Forget this project on this device",
  },
  promotion: {
    eyebrow: "WHEN A STARTING POINT IS NOT ENOUGH",
    headline: "A tool can set the light. It cannot make the pitch.",
    body: "If the story, structure, evidence, or deck itself needs a human team, pitch.dog does that work. No trapdoor. No hostage email. No sudden sales rep rappelling from the ceiling. You already have the complete palette this tool can honestly give.",
    action: "See how pitch.dog can help",
  },
} as const;

export type ColorPleaseCopy = typeof copy;
